import * as tslib_1 from "tslib";
import { NgModule } from '@angular/core';
import { NgForageCache } from './cache/NgForageCache.service';
import { BaseConfigurableImpl } from './config/BaseConfigurableImpl.service';
import { NgForageConfig } from './config/NgForageConfig.service';
import { InstanceFactory } from './instance-factory/InstanceFactory.service';
import { NgForage } from './main/NgForage.service';
/**
 * NgForage core module
 */
var NgForageModule = (function () {
    function NgForageModule() {
    }
    NgForageModule = tslib_1.__decorate([
        NgModule({
            providers: [
                NgForage,
                NgForageCache,
                BaseConfigurableImpl,
                NgForageConfig.provider,
                InstanceFactory.provider
            ]
        })
    ], NgForageModule);
    return NgForageModule;
}());
export { NgForageModule };



//////////////////
// WEBPACK FOOTER
// ./src/NgForage/NgForage.module.ts
// module id = 10
// module chunks = 0 1